import { homeConstants } from "../constants";

export default function (
  state = {
    data: {},
    isProgress: false,
    message: "",
    zipDataStatus: true,
    currentLocation: null,
    error:null
  },
  action
) {
  switch (action.type) {
    case homeConstants.SET_CURRENT_LOCATION:
      return { ...state, currentLocation: action.currentLocation };

    case homeConstants.ZIP_SEARCH_RESULTS_REQUEST:
      return {
        ...state,
        message: "",
        zipDataStatus: true,
        isProgress: true,
        data: {},
        error: null,
      };
    case homeConstants.ZIP_SEARCH_RESULTS_SUCCESS: {
      let result = JSON.parse(localStorage.getItem("storedZipData"));
      if (action.response.data && action.response.success) {
        localStorage.setItem(
          "storedZipData",
          JSON.stringify(action.response.data)
        );
        result = action.response.data;
      }
      return {
        ...state,
        data: result || {},
        message: action.response.message || "",
        zipDataStatus: action.response.success,
        isProgress: false,
        error:null
      };
    }
    case homeConstants.ZIP_SEARCH_RESULTS_FAILURE:
      return {
        ...state,
        data: {},
        message: action?.error?.message || "",
        error: action.error,
        zipDataStatus: false,
        isProgress: false,
      };
    case homeConstants.RESET_ZIP_SEARCH:
      return {
        ...state,
        message: "",
        zipDataStatus: true,
        error: null,
      };
    default:
      return state;
  }
}
